import {Injectable} from '@angular/core';
import {Browser} from "@capacitor/browser";
import {StorageService} from "./storage.service";
import {ModalController} from "@ionic/angular/lazy";
import {ModalPageComponent} from "../components/modal-page/modal-page.component";
import {CompleteDetailsModalComponent} from "../components/complete-details-modal/complete-details-modal.component";
import {Subject} from "rxjs";
@Injectable({
    providedIn: 'root'
})
export class UtilityService {
    constructor(
        private modalCtrl: ModalController,
    ) {}

    /**
     * Format Date into readable value for users
     * @param unix_timestamp
     */
    formatDate(unix_timestamp: any) {
        if (unix_timestamp === null) {
            return '--';
        }
        let date = new Date(unix_timestamp),
            year = date.toLocaleString("default", {year: "numeric"}),
            month = date.toLocaleString("default", {month: "short"}),
            day = date.toLocaleString("default", {day: "2-digit"}),
            hours = date.getHours(),
            minutes = "0" + date.getMinutes();

        return hours + ':' + minutes.slice(-2) + " | " + day + " " + month + " " + year;
    }


    /**
     * Validate Email format
     * @param email
     */
    validateEmail(email: any) {
        let regexEmail = /^\w+([.-]?\w+)*@\w+([.-]?\w+)*(\.\w{2,3})+$/;
        return regexEmail.test(email);
    }

    /** Validate Password - Minimum 8 chars, at least one letter and one number */
    validatePassword(password: any) {
        let regexPassword = /^(?=[^A-Z]*[A-Z])(?=[^a-z]*[a-z])(?=\D*\d).{10,}$/;
        return regexPassword.test(password);
    }


    validatePasswordStrength(password: any) {
        let strength = 0;
        let passwordStrength = '';

        if (password.length >= 10) strength += 1;
        if (/[A-Z]/.test(password)) strength += 1;
        if (/[0-9]/.test(password)) strength += 1;
        if (/[\W]/.test(password)) strength += 1;

        switch (strength) {
            case 0:
                passwordStrength = '';
                break;
            case 1:
                passwordStrength = 'weak';
                break;
            case 2:
                passwordStrength = 'medium';
                break;
            case 3:
                passwordStrength = 'good';
                break;
            case 4:
                passwordStrength = 'strong';
                break;
            default:
                passwordStrength = '';
                break;
        }
    }

    /**
     * Validate Form Builder Group key
     * @param key
     * @param errorType
     * @param form
     */
    validateField(key: string, errorType: string, form: any) {
        let field = form.get(key);
        return field.hasError(errorType) && (field.dirty || field.touched)
    }

    /**
     * Get the key value of enums
     * @param objEnum
     * @param val
     */
    getEnumKey(objEnum: any, val: any) {
        let indexOf = Object.values(objEnum).indexOf(val);
        if (indexOf > -1) {
            return Object.keys(objEnum)[Object.values(objEnum).indexOf(val)];
        }
        return null;
    }

    async openExternalLink(url: string) {
        await Browser.open({ url: url });
    }


    pageModal : any;
    /**
     * Open Order View Modal for details
     */
    async openPageModal(pageSlug : string) {
        this.pageModal = await this.modalCtrl.create({
            component: ModalPageComponent,
            componentProps: {
                pageSlug : pageSlug
            },
            cssClass: 'safe-area'
        });
        this.pageModal.onDidDismiss().then((response: any) => {});
        await this.pageModal.present();
    }

    /**
     * Open the "complete your account details" modal (registration_type + crime types).
     * Resolves to true when the user saved the details, false otherwise.
     */
    async openCompleteDetailsModal(): Promise<boolean> {
        const modal = await this.modalCtrl.create({
            component: CompleteDetailsModalComponent,
            cssClass: 'safe-area complete-details-modal',
        });
        await modal.present();
        const { data } = await modal.onDidDismiss();
        return !!data?.saved;
    }


    private skipSubject = new Subject<number | string>();
    readonly skip$ = this.skipSubject.asObservable();

    emitSkip(stepToken: number | string) {
        this.skipSubject.next(stepToken);
    }
}
